const guiColors = {
    'motion-primary': 'hsla(45, 100%, 50%, 1)',
    'motion-primary-transparent': 'hsla(45, 100%, 50%, 0.9)',
    'motion-tertiary': 'hsla(45, 100%, 40%, 1)',

    'looks-secondary': 'hsla(45, 100%, 50%, 1)',
    'looks-transparent': 'hsla(45, 100%, 50%, 0.35)',
    'looks-light-transparent': 'hsla(45, 100%, 50%, 0.15)',
    'looks-secondary-dark': 'hsla(45, 100%, 40%, 1)',

    'extensions-primary': 'hsla(55, 85%, 50%, 1)',
    'extensions-tertiary': 'hsla(55, 85%, 25%, 1)',
    'extensions-transparent': 'hsla(55, 85%, 50%, 0.35)',
    'extensions-light': 'hsla(55, 57%, 70%, 1)',

    'drop-highlight': 'hsl(45, 100%, 63%)'
};

const blockColors = {
    checkboxActiveBackground: 'hsl(45, 100%, 50%)',
    checkboxActiveBorder: 'hsl(45, 100%, 40%)'
};

export {
    guiColors,
    blockColors
};